import { CSSObject } from '@emotion/core';
import Link from 'next/link';
import { useMemo } from 'react';

import { useBrands } from '@api/catalog/brand';

import Carousel from '@components/controls/Carousel';
import Picture from '@components/controls/future/Picture';

import { colors, scale } from '@scripts/gds';

const buttonOptionStyles: CSSObject = {
    height: scale(10),
    width: scale(25),
    position: 'relative',
    border: `1px solid ${colors.borderMain}`,
};

const BrandsCarousel = () => {
    const { data: apiBrands } = useBrands({ filter: { is_popular: true } });
    const popularBrands = useMemo(() => apiBrands?.data, [apiBrands]);

    return popularBrands ? (
        <Carousel
            spaceBetween={scale(3, true)}
            type="products"
            slidesPerView="auto"
            navigation
            title="Популярные бренды"
        >
            {popularBrands.map((item, index) => (
                <Carousel.Item key={index}>
                    <Link legacyBehavior href={`/brands/${item?.code}-${item.id}`} passHref prefetch={false}>
                        <a css={buttonOptionStyles} aria-label={item.name}>
                            {item?.image_url && (
                                <Picture
                                    sources={[
                                        {
                                            media: '',
                                            image: item.image_url,
                                        },
                                    ]}
                                    loading="lazy"
                                    blurDataURL={item.image_url}
                                    placeholder="blur"
                                    alt={item.name}
                                    width="auto"
                                    height="auto"
                                    style={{
                                        objectFit: 'contain',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
                            )}
                        </a>
                    </Link>
                </Carousel.Item>
            ))}
        </Carousel>
    ) : null;
};

export default BrandsCarousel;
